import styles from './styles.module.scss';

import SidebarFieldHeader from './SidebarFieldHeader.jsx';

const SidebarField = ({ t, title, crop, startDate, endDate, isActive, onClickItem, children }) => {
  return (
    <div className={`${styles.sidebarField} ${isActive ? styles.sidebarFieldActive : ''}`}>
      {onClickItem ? (
        <button className={styles.sidebarFieldHeader} onClick={onClickItem}>
          <SidebarFieldHeader t={t} title={title} crop={crop} startDate={startDate} endDate={endDate} />
        </button>
      ) : (
        <div className={styles.sidebarFieldHeader}>
          <SidebarFieldHeader t={t} title={title} crop={crop} startDate={startDate} endDate={endDate} />
        </div>
      )}
      {children}
    </div>
  );
};

export default SidebarField;
